export const SUPPORTED_LANGUAGES = [
  'en',
  'da',
  'sv',
  'de',
  'fr',
  'es',
  'nl',
  'pl',
  'fi',
  'ro'
] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  en: 'English',
  da: 'Danish',
  sv: 'Swedish',
  de: 'German',
  fr: 'French',
  es: 'Spanish',
  nl: 'Dutch',
  pl: 'Polish',
  fi: 'Finnish',
  ro: 'Romanian'
};

export const INTERVIEW_MODALITY = ['text', 'voice'] as const;
export type InterviewModality = (typeof INTERVIEW_MODALITY)[number];

export const SCREENING_OUTCOME = ['pass', 'fail', 'incomplete'] as const;
export type ScreeningOutcome = (typeof SCREENING_OUTCOME)[number];
